import { render, staticRenderFns } from "./PatientDetails.vue?vue&type=template&id=4c8fd3b2&scoped=true&"
import script from "./PatientDetails.vue?vue&type=script&lang=tsx&"
export * from "./PatientDetails.vue?vue&type=script&lang=tsx&"
import style0 from "./PatientDetails.vue?vue&type=style&index=0&id=4c8fd3b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8fd3b2",
  null
  
)

export default component.exports